import { REMOVE_MY_BRANDS_ACCOUNT_MENU_CONDITION_240814 } from "@faire/web-api/indigofair/settings/REMOVE_MY_BRANDS_ACCOUNT_MENU_CONDITION_240814";

import { useSetting, useAssignSetting } from "./__internal__/useSetting";

export const useSettingRemoveMyBrandsAccountMenuCondition = (): boolean =>
  useSetting(REMOVE_MY_BRANDS_ACCOUNT_MENU_CONDITION_240814, false);

export const useAssignSettingRemoveMyBrandsAccountMenuCondition = () =>
  useAssignSetting(REMOVE_MY_BRANDS_ACCOUNT_MENU_CONDITION_240814);
